import { render, staticRenderFns } from "./InboundOneClickAction.vue?vue&type=template&id=79f54cd9&scoped=true"
import script from "./InboundOneClickAction.vue?vue&type=script&lang=js"
export * from "./InboundOneClickAction.vue?vue&type=script&lang=js"
import style0 from "./InboundOneClickAction.vue?vue&type=style&index=0&id=79f54cd9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f54cd9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79f54cd9')) {
      api.createRecord('79f54cd9', component.options)
    } else {
      api.reload('79f54cd9', component.options)
    }
    module.hot.accept("./InboundOneClickAction.vue?vue&type=template&id=79f54cd9&scoped=true", function () {
      api.rerender('79f54cd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/default/InboundOneClickAction.vue"
export default component.exports